import React from 'react'
import axios from "axios";
import {useEffect, useState} from "react";
import {useLocation, useSearchParams , Link, useNavigate} from "react-router-dom";
import { GoogleLogout } from 'react-google-login';

export default function All() {
    var x=0;
    const [loading,isLoading]= useState(true)
    const [searchParams, setSearchParams] = useSearchParams();
    // const [id,setId]= useState("")
    const [teams,setTeams]= useState(["loading"])
    const [name2,setName2] =useState("")
    const navigate = useNavigate();
useEffect(()=>{
    var id=sessionStorage.getItem("gid")
    var name=sessionStorage.getItem("gname")
    setName2(name)
    // console.log(name2)
     axios.get(`https://spliteasy.onrender.com/auth/id/${id}`).then((res)=>{
      
        setTeams(res.data)
        console.log(res.data)
        isLoading(false)
        if(res.data.length==0)
        {
        document.getElementById("nogrpimage").style.display="initial"
        document.getElementById("grp").innerText="No group found !!!"
        }
       })
   
},[])

if (loading) {
    return <div className="App2">Loading...</div>;
  }


const logout=()=>{

    sessionStorage.clear("gid")
    sessionStorage.clear("gname")
    // console.log("logged out")
    navigate(`/`);
}

function image()
{   
   
    var i=0;
    setInterval(()=>{
      i++;
        if(i%2==0)
        document.getElementById("img").src="./travel2.jpg";
        else
        document.getElementById("img").src="./travel1.jpg";

    },1000)
}

image()



  return (
    <div className='center '>
 
    <p onClick={logout} className='right color2'>Logout</p>

    <div className='title'>SplitEasy</div>
      
    <div className='navbar' style={{"float":"left", "marginLeft":"25px"}} >
    <p className='hello'>Hello</p>
    <br/>
    <p className='nav-name'>{name2.toUpperCase().split(" ")[0] +" " + name2.toUpperCase().split(" ")[1]}</p>
    </div>

    <img id="img" className='travelimage' src='./travel1.jpg'></img>   


<br/>


<div className='bottom'>
      <h2 id="grp" className='grp'>Groups</h2>

  <div className='tabs'>  
  <img id='nogrpimage' style={{"display":"none"}} src="./empty.jpg"></img>
  
{
    
    teams.map((o,index,key2)=>{
       
        return(
            <div className='teamslist' id={`disp${index}`} >
                <Link className='select' to={`/home?team=${teams[teams.length-index-1].team}`}>Select</Link>
                <p  className='teamname' >{teams[teams.length-index-1].team}</p>
                <h5  className='date'>{new Date(teams[teams.length-index-1].createdAt).toDateString()}</h5>
                <br/>
            </div>
             )
    })
}
</div>
    
    </div>
    <h2 onClick={()=>{navigate("/new")}} className='newgrp'>+</h2>
    <p style={{"margin":"0px"}}>Created and Managed by Arpit Singhal</p>
    <p style={{"margin":"0px"}}>(Student IIT Hyderabad)</p>
    </div>
  )

  
}
